export default "__VITE_ASSET__8153c983__"